import { render, staticRenderFns } from "./CardHorizontal.vue?vue&type=template&id=a45bc7e4&scoped=true&"
import script from "./CardHorizontal.vue?vue&type=script&lang=js&"
export * from "./CardHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45bc7e4",
  null
  
)

export default component.exports